import React, { Component, PropTypes } from 'react';
import { style } from './style';
import { RaisedButton, FlatButton } from 'material-ui';
import { Grid, Row, Col } from 'react-flexbox-grid';
import MenuItem from 'material-ui/MenuItem';
import * as actions from '../.././actions';
import BtnAddUser from './ManageUsers';
import { Provider, connect } from 'react-redux';
import { bindActionCreators, createStore } from 'redux';
import autoBind from 'react-autobind';
import { Field, reduxForm } from 'redux-form';
import validator from 'validator';
import { TextField, SelectField } from 'redux-form-material-ui';


const validate = values => {
  const errors = {};
  //validation 
  errors.mail = validator.isEmail(values.mail ? values.mail : "") ? null : 'Không phải là địa chỉ mail';
  errors.password = validator.isLength(values.password ? values.password : "",6) ? null : 'Mật khẩu phải 6 ký tự trở lên';
  errors.login = validator.isLength(values.login ? values.login : "",6) ? null : 'Tên đăng nhập phải 6 ký tự trở lên';
  const requiredFields = [ 'firstname', 'lastname', 'mail', 'login', 'password' , 'projectId'];
  requiredFields.forEach(field => {
    if (!values[ field ]) {
      errors[ field ] = 'Không được để trống';
    }})
  return errors;
}

// const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

// const asyncValidate = (values/*, dispatch */) => {
//   return sleep(1000) // simulate server latency
//     .then(() => {
//       if ([ 'foo@foo.com', 'bar@bar.com' ].includes(values.email)) {
//         throw { email: 'Email already Exists' }
//       }
//     })
// }

export class AddUser extends Component {

    constructor(props) {
        super(props);
        this.state = {
            login: '',
            password: '',
            mail: '',
            firstname: '',
            lastname: '',
            projectId: 63,
            admin: 0
        };
        autoBind(this);
    }

    handleAddUser({login,password,mail,lastname,firstname,projectId}) {
        this.state.login = login;
        this.state.password = password;
        this.state.mail = mail;
        this.state.lastname = lastname;
        this.state.firstname = firstname;
        this.state.projectId = projectId;
        this.props.dispatch(actions.createUser(this.state))
        this.props.handleClose();
    }

    handleChangeLevel(event, index, value) {
        this.setState({
            projectId: value
        });
    }

    render() {
        const {handleSubmit,pristine,submitting} = this.props;
        return (
            <div>
              <Row>
                <Col xs={ 12 }>
                <Row>
                  <Col xs={ 6 }>
                  <Field 
                    name="login" 
                    component={TextField} 
                    hintText="Tên đăng nhập" 
                    floatingLabelText="Tên đăng nhập" 
                    fullWidth={ true } 
                    underlineShow={ true } 
                  />
                  <Field 
                    name="password" 
                    component={TextField} 
                    hintText="Mật khẩu" 
                    floatingLabelText="Mật khẩu" 
                    fullWidth={ true } 
                    underlineShow={ true } 
                    type="password"
                  />
                  <Field 
                    name="mail" 
                    component={TextField} 
                    hintText="Email" 
                    floatingLabelText="Email" 
                    fullWidth={ true } 
                    underlineShow={ true } 
                  />
                  </Col>
                  <Col xs={ 6 }>
                    <Field 
                    name="lastname" 
                    component={TextField} 
                    hintText="Họ" 
                    floatingLabelText="Họ" 
                    fullWidth={ true } 
                    underlineShow={ true } 
                  />
                    <Field 
                      name="firstname" 
                      component={TextField} 
                      hintText="Tên" 
                      floatingLabelText="Tên" 
                      fullWidth={ true } 
                      underlineShow={ true } 
                    />
                    <Field 
                      name="projectId" 
                      component={SelectField} 
                      hintText="Dự án" 
                      floatingLabelText="Dự án">
                      < MenuItem value={ 63 } primaryText="Itracking" />
                      < MenuItem value={ 65 } primaryText="Smartbike" />
                    </Field>
                  </Col>
                </Row>
                <div style={ { marginTop: '10%' } }>
                  <Row>
                    <Col xs={ 12 }>
                    <Row center='xs'>
                      <Col xs={ 4 }>
                      <Row>
                        <Col xs>
                        <FlatButton label="Hủy" onTouchTap={ this.props.handleClose } />
                        </Col>
                        <Col xs>
                        <RaisedButton  disabled={pristine || submitting} label="Thêm" primary={ true } keyboardFocused={ true } onTouchTap={ handleSubmit(this.handleAddUser) } />
                        </ Col>
                      </Row>
                      </Col>
                    </Row>
                    </Col>
                  </Row>
                </div>
                </Col>
              </Row>
            </div>
            );
    }
}

export default reduxForm({
  form: 'createUser', // a unique identifier for this form
  validate,
  // asyncValidate,
})(AddUser);


// WEBPACK FOOTER //
// ./src/components/users/add.js